<template>
  <v-card>
    <v-card-title class="primary">
      <span class="headline white--text">
        {{ title }}
      </span>
      <v-spacer/>
      <BaseDialogActions hideRefresh hideFullscreen @close="closeForm"/>
    </v-card-title>
    <v-card-text>
      <FormWrapper
      testId="yard-instruction-form-save-btn"
      @submit="saveChanges">
        <template #left-action>
            <v-row align="center" justify="space-between">
              <v-col cols="auto">
                <v-checkbox
                v-model="instruction.isDefault"
                :label="$t('isDefault')"
                color="primary"
                class="mr-3"/>
              </v-col>

              <v-col cols="auto">
                <v-checkbox
                v-if="propInstruction"
                v-model="instruction.status"
                data-testid="instruction-status-check"
                color="primary"
                :label="$t('active')"/>
              </v-col>
            </v-row>
        </template>
        <v-container fluid grid-list-md>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
              ref="firstField"
              color="black"
              data-testid="instruction-name"
              :rules="[rules.required]"
              :label="$t('name')"
              v-model="instruction.name"
              maxlength="32"
              counter
              />
            </v-col>
          </v-row>
        </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import fieldRules from '@/utils/rules'
import { cloneDeep } from 'lodash'
import { mapActions } from 'vuex'
import { YardInstructionStatus } from '@/utils/Enumerations.js'

export default {
  name: 'YardInstructionDialog',

  props: {
    propInstruction: {
      type: Object,
      default: undefined
    },
    location: {
      type: Object,
      required: true
    }
  },

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue')
  },

  data: () => ({
    rules: fieldRules.rules,
    instruction: {
      name: '',
      status: true,
      isDefault: false
    }
  }),

  computed: {
    title () {
      if (this.propInstruction) {
        return this.$t('editingYardInstruction', { instruction: this.propInstruction.instruction })
      } else {
        return this.$t('creatingYardInstruction')
      }
    }
  },

  created () {
    if (this.propInstruction) {
      this.instruction = {
        name: this.propInstruction.name,
        status: this.propInstruction.status === YardInstructionStatus.Active.value,
        isDefault: this.propInstruction.isDefault
      }
    } else {
      if (this.location.yardInstructions.length === 0) {
        this.instruction.isDefault = true
      }
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.firstField.focus()
    }, 0)
  },

  methods: {
    ...mapActions('yard-instructions', ['createYardInstruction', 'updateYardInstruction']),
    async saveChanges () {
      if (!this.validateInstruction()) {
        return
      }

      const requestObj = cloneDeep(this.instruction)
      requestObj.status = requestObj.status ? YardInstructionStatus.Active.value : YardInstructionStatus.Paused.value
      requestObj.locationId = this.location.locationId

      if (this.propInstruction) {
        requestObj.yardInstructionId = this.propInstruction.yardInstructionId
        await this.updateYardInstruction(requestObj)
        return this.$emit('instruction-saved')
      }

      await this.createYardInstruction(requestObj)
      this.$emit('instruction-saved')
    },

    closeForm () {
      this.$emit('close')
    },

    validateInstruction () {
      const name = this.instruction.name
      if (name.trim() === '') {
        this.setSnackError(this.$t('instructionNameError'))
        return false
      }

      return true
    }
  }
}
</script>
